import React, { useEffect, useState } from "react";
import {
  formatDate,
  formatDateList,
  modalInitialValue,
  regName,
  trim,
} from "../../helpers/commonHelpers";
import ModalContainer from "../Modal";
import { Tabs } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Heading from "../Heading";
import CardContainer from "../Card/cardContainer";
import { meetingListAction } from "../actions/meetingAction";
import { apipaths } from "../../services/apiPaths";
import Swal from "sweetalert2";
import { sendRequest } from "../../services";
import "bootstrap/dist/css/bootstrap.css";
import useTranslation from "../customHooks/translations";
import * as moment from "moment";
import dayjs from "dayjs";
import { DatePicker, Space } from "antd";
import { employeesListAction } from "../actions/employeesListAction";
import { clientListAction } from "../actions/clientAction";
import { projectListAction } from "../actions/projectAction";
const { RangePicker } = DatePicker;

const EditMeeting = () => {
  const [modal, setModal] = useState(modalInitialValue);
  const [selectMeeting, setSelectMeeting] = useState({});
  const [formData, setFormData] = useState({});
  const [preStartDate, setPreStartDate] = useState("");
  const [preEndDate, setPreEndDate] = useState("");
  const [date, setDate] = useState("");

  const [postStartDate, setPostStartDate] = useState("");
  const [postEndDate, setPostEndDate] = useState("");

  const { employees } = useSelector((state) => state.employee);
  const { projects } = useSelector((state) => state.project);
  const { clients } = useSelector((state) => state.client);
  const { companies } = useSelector((state) => state.company);
  const { meet } = useSelector((state) => state.meet);

  const { TabPane } = Tabs;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: meetingId } = useParams();
  const translation = useTranslation();

  useEffect(() => {
    if (meet.length > 0) {
      let meetMap = meet.filter(
        (com) => parseInt(com.meeting_id) == parseInt(meetingId)
      );
      setSelectMeeting(meetMap[0]);
    }
  }, [meet]);

  useEffect(() => {
    dispatch(meetingListAction());
    dispatch(employeesListAction());
    dispatch(clientListAction());
    dispatch(projectListAction());
  }, []);

  const fillClient = clients.filter((d) => {
    return d.company_id == formData.company_id;
  });

  const fillProject = projects.filter((d) => {
    return d.client_id == formData.client_id;
  });

  const updateMeetingHandler = async () => {
    if (!regName.test(formData.subject)) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please Fill Out Meeting Subject !",
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      let form_data = {
        ...formData,
      };
      form_data = {
        ...form_data,
        startdate: date,
        Pre_startdate: preStartDate,
        Pre_enddate: preEndDate,
        Post_startdate: postStartDate,
        Post_enddate: postEndDate,
      };

      form_data["id"] = selectMeeting.meeting_id;
      form_data["operation"] = "update";

      delete form_data.created_at;
      delete form_data.updated_at;
      delete form_data.company;
      delete form_data.user_id;
      delete form_data.employee;
      delete form_data.meeting_id;
      delete form_data.enable;

      const { success, message } = await sendRequest(
        apipaths.addMeeting,
        form_data
      );
      if (success) {
        navigate(-1);
        dispatch(meetingListAction());
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Meeting Update Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    }
  };
  const onInputChange = (e) => {
    const target = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [target.name]: target.value,
    }));
  };

  const onCancel = () => {
    navigate(-1);
  };

  const handleEvent = (event, picker) => {
    setPreStartDate(formatDate(event[0]));
    setPreEndDate(formatDate(event[1]));
  };

  const handleEventPost = (event, picker) => {
    setPostStartDate(formatDate(event[0]));
    setPostEndDate(formatDate(event[1]));
  };

  const dateChange = (date) => {
    handleEvent(date);
  };

  const dateChangePost = (date) => {
    handleEventPost(date);
  };

  const selectDate = (date) => {
    setDate(formatDateList(date));
  };

  const dateFormat = "YYYY/MM/DD";

  return (
    <>
      <ModalContainer
        isOpen={modal.open}
        title={modal.title}
        closeIcon={() => setModal(modalInitialValue)}
        content={modal.content}
        footer={false}
      />

      <div className="main-container">
        <Heading title={translation.edit_meetings} />
        <div className="content-wrapper px-5">
          <CardContainer hideTotal={true} />
        </div>
        <div className="main-content-wrapper">
          <Tabs defaultActiveKey="1" onChange={(key) => key}>
            <Tabs.TabPane
              tab={translation.meetings}
              key="item-1"
              className="row"
            >
              <div class="col-12 col-md-6 col-lg-9">
                <label for="Meetings" class="form-label">
                  {translation.meetings}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="subject"
                  aria-describedby="emailHelp"
                  placeholder="Meetings"
                  name="subject"
                  key="subject"
                  defaultValue={selectMeeting.subject}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <label for="Date" class="form-label">
                  {translation.date}
                </label>
                {/* {selectMeeting.startdate ? ( */}
                <DatePicker
                  className="w-100"
                  name="startdate"
                  key="startdate"
                  value={selectDate?.date}
                  placeholder={translation.select_date}
                  onChange={(date) => selectDate(date)}
                  style={{ borderRadius: "0.375rem" }}
                  defaultValue={moment(formatDateList(selectMeeting.startdate))}
                />
                {/* ) : ( */}
                {/* <DatePicker
                  className="w-100"
                  name="startdate"
                  key="startdate"
                  placeholder={translation.select_date}
                  onChange={(date) => selectDate(date)}
                  style={{ borderRadius: "0.375rem" }}
                /> */}
                {/* )} */}
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="Start Time" class="form-label">
                  {translation.start_time}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="starttime"
                  aria-describedby="emailHelp"
                  placeholder="Time"
                  name="starttime"
                  key="starttime"
                  defaultValue={selectMeeting.starttime}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="End Time" class="form-label">
                  {translation.end_time}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="endtime"
                  aria-describedby="emailHelp"
                  placeholder="Time"
                  name="endtime"
                  key="endtime"
                  defaultValue={selectMeeting.endtime}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="Venue" class="form-label">
                  {translation.venue}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="venue"
                  aria-describedby="emailHelp"
                  placeholder="Venue"
                  name="venue"
                  key="venue"
                  defaultValue={selectMeeting.venue}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="Company" class="form-label">
                  {translation.company}
                </label>
                <select
                  class="form-select"
                  aria-label="Select Company"
                  key="company_id"
                  defaultValue={selectMeeting.company_id}
                  onChange={onInputChange}
                  name="company_id"
                >
                  {" "}
                  <option selected>{translation.select_company}</option>
                  {companies.map((d, i) => (
                    <option key={d.company_id} value={d.company_id}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="Client" class="form-label">
                  {translation.client}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Client"
                  key="client_id"
                  onChange={onInputChange}
                  defaultValue={selectMeeting.client_id}
                  name="client_id"
                >
                  {" "}
                  <option selected>{translation.select_client}</option>
                  {fillClient.map((c, i) => (
                    <option key={c.client_id} value={c.client_id}>
                      {c.first_name + "" + c.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-3">
                <label for="Project" class="form-label">
                  {translation.project}
                </label>
                <select
                  class="form-select"
                  aria-label=" select Project"
                  id="project_id"
                  key="project_id"
                  onChange={onInputChange}
                  defaultValue={selectMeeting.project_id}
                  name="project_id"
                >
                  <option selected>{translation.select_project}</option>
                  {fillProject.map((p, i) => (
                    <option key={p.project_id} value={p.project_id}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Incharge Employee" class="form-label">
                  {translation.incharge_employee}
                </label>
                <select
                  class="form-select"
                  aria-label="Select Incharge Employee"
                  key="employee_id"
                  onChange={onInputChange}
                  defaultValue={selectMeeting.employee_id}
                  id="employee_id"
                  name="employee_id"
                >
                  <option selected>
                    {translation.select_incharge_employee}
                  </option>
                  {employees.map((e, i) => (
                    <option key={e.employee_id} value={e.employee_id}>
                      {e.first_name + " " + e.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-9 mt-3">
                <label for="Attendees" class="form-label">
                  {translation.attendees}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="attendees"
                  aria-describedby="emailHelp"
                  placeholder="Attendees"
                  name="attendees"
                  key="attendees"
                  defaultValue={selectMeeting.attendees}
                  onChange={onInputChange}
                />
              </div>

              <div class="col-12  mt-3">
                <label for="Description" class="form-label">
                  {translation.description}
                </label>
                <textarea
                  class="form-control"
                  id="desc"
                  placeholder="Description"
                  name="desc"
                  key="desc"
                  defaultValue={selectMeeting.desc}
                  onChange={onInputChange}
                ></textarea>
              </div>
              <div class="col-12 col-md-6 col-lg-6 mt-3">
                <label for="Remarks" class="form-label">
                  {translation.remarks}
                </label>
                <textarea
                  class="form-control"
                  placeholder="Remarks"
                  id="remarks"
                  key="remarks"
                  defaultValue={selectMeeting.remarks}
                  onChange={onInputChange}
                  name="remarks"
                ></textarea>
              </div>
              <div class="col-12 col-md-6 col-lg-6 mt-3">
                <label for="Keypoints" class="form-label">
                  {translation.keypoints}
                </label>
                <textarea
                  class="form-control"
                  id="keypoints"
                  key="keypoints"
                  name="keypoints"
                  placeholder="KeyPoints"
                  defaultValue={selectMeeting.keypoints}
                  onChange={onInputChange}
                ></textarea>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={translation.pre_task}
              key="item-2"
              className="row"
            >
              <div class="col-12 col-md-6 col-lg-8">
                <label for="Subject" class="form-label">
                  {translation.subject}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="Pre_subject"
                  aria-describedby="emailHelp"
                  placeholder="Subject"
                  name="Pre_subject"
                  key="Pre_subject"
                  defaultValue={selectMeeting?.pre_task?.subject}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <label for="Due Date" class="form-label">
                  {translation.start__end_date}
                </label>
                <RangePicker
                  className="form-control border-none rounded-lg"
                  onChange={(date) => dateChange(date)}
                  placeholder={["Start & End Date"]}
                  defaultValue={[
                    moment(
                      formatDate(selectMeeting?.pre_task?.startdate, dateFormat)
                    ),
                    moment(
                      formatDate(selectMeeting?.pre_task?.enddate, dateFormat)
                    ),
                  ]}
                  format={dateFormat}
                />

                {/* <RangePicker
                  onChange={(date) => dateChange(date)}
                  defaultValue={[
                    moment(selectMeeting?.pre_task?.startdate, dateFormat),
                    moment(selectMeeting?.pre_task?.enddate, dateFormat),
                  ]}
                  format={dateFormat}
                /> */}
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Priority" class="form-label">
                  {translation.priority}
                </label>
                <select
                  class="form-select"
                  aria-label="Select Priority"
                  key="Pre_priority"
                  onChange={onInputChange}
                  id="Pre_priority"
                  defaultValue={selectMeeting?.pre_task?.priority}
                  name="Pre_priority"
                >
                  <option selected>Select Priority</option>
                  <option value="Urgent">Urgent</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Status" class="form-label">
                  {translation.status}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Status"
                  key="Pre_status"
                  onChange={onInputChange}
                  name="Pre_status"
                  defaultValue={selectMeeting?.pre_task?.status}
                >
                  {" "}
                  <option selected>Select Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Started">Started</option>
                  <option value="Inprogress">Inprogress</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Task Assigned To" class="form-label">
                  {translation.task_assigned_to}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Task Assigned To"
                  key="Pre_task_assign_to"
                  onChange={onInputChange}
                  defaultValue={selectMeeting?.pre_task?.task_assign_to}
                  name="Pre_task_assign_to"
                >
                  {" "}
                  <option selected>Task Assigned To</option>
                  {employees.map((e, i) => (
                    <option key={e.employee_id} value={e.employee_id}>
                      {e.first_name + " " + e.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Employee" class="form-label">
                  {translation.employee}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Employee"
                  key="Pre_employee_id"
                  onChange={onInputChange}
                  defaultValue={selectMeeting?.pre_task?.employee_id}
                  name="Pre_employee_id"
                >
                  {" "}
                  <option selected>Employee</option>
                  {employees.map((e, i) => (
                    <option key={e.employee_id} value={e.employee_id}>
                      {e.first_name + " " + e.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="col-12  mt-2">
                <label for="Description" class="form-label">
                  {translation.description}
                </label>
                <textarea
                  class="form-control"
                  id="Pre_desc"
                  rows="3"
                  placeholder="Describe Here"
                  name="Pre_desc"
                  key="Pre_desc"
                  defaultValue={selectMeeting?.pre_task?.desc}
                  onChange={onInputChange}
                ></textarea>
              </div>
              <div class="col-12  mt-2">
                <label for="Remarks" class="form-label">
                  {translation.remarks}
                </label>
                <textarea
                  class="form-control"
                  id="Pre_remarks"
                  rows="3"
                  placeholder="Remarks Here"
                  name="Pre_remarks"
                  key="Pre_remarks"
                  defaultValue={selectMeeting?.pre_task?.remarks}
                  onChange={onInputChange}
                ></textarea>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={translation.post_task}
              key="item-3"
              className="row"
            >
              <div class="col-12 col-md-6 col-lg-8">
                <label for="Subject" class="form-label">
                  {translation.subject}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="Post_subject"
                  aria-describedby="emailHelp"
                  placeholder="Subject"
                  name="Post_subject"
                  key="Post_subject"
                  defaultValue={selectMeeting?.post_task?.subject}
                  onChange={onInputChange}
                />
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <label for="Due Date" class="form-label">
                  {translation.start__end_date}
                </label>
                <RangePicker
                  className="form-control border-none rounded-lg"
                  placeholder={["Start & End Date"]}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => dateChangePost(date)}
                  defaultValue={[
                    moment(formatDate(selectMeeting?.post_task?.startdate)),
                    moment(formatDate(selectMeeting?.post_task?.enddate)),
                  ]}
                />
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Priority" class="form-label">
                  {translation.priority}
                </label>
                <select
                  class="form-select"
                  aria-label="Select Priority"
                  key="Post_priority"
                  onChange={onInputChange}
                  id="Post_priority"
                  defaultValue={selectMeeting?.post_task?.priority}
                  name="Post_priority"
                >
                  <option selected>{translation.select_priority}</option>
                  <option value="Urgent">Urgent</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Status" class="form-label">
                  {translation.status}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Status"
                  key="Post_status"
                  onChange={onInputChange}
                  defaultValue={selectMeeting?.post_task?.status}
                  name="Post_status"
                >
                  {" "}
                  <option selected>{translation.select_status}</option>
                  <option value="Pending">Pending</option>
                  <option value="Started">Started</option>
                  <option value="Inprogress">Inprogress</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Task Assigned To" class="form-label">
                  {translation.task_assigned_to}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Task Assigned To"
                  key="Post_task_assign_to"
                  onChange={onInputChange}
                  defaultValue={selectMeeting?.post_task?.task_assign_to}
                  name="Post_task_assign_to"
                >
                  {" "}
                  <option selected>{translation.task_assigned_to}</option>
                  {employees.map((e, i) => (
                    <option key={e.employee_id} value={e.employee_id}>
                      {e.first_name + " " + e.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="mb-2 col-lg-3 mt-3">
                <label for="Employee" class="form-label">
                  {translation.employee}
                </label>
                <select
                  class="form-select"
                  aria-label=" Select Employee"
                  key="Post_employee_id"
                  onChange={onInputChange}
                  name="Post_employee_id"
                  defaultValue={selectMeeting?.post_task?.employee_id}
                >
                  {" "}
                  <option selected>{translation.employee}</option>
                  {employees.map((e, i) => (
                    <option key={e.employee_id} value={e.employee_id}>
                      {e.first_name + " " + e.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="col-12  mt-2">
                <label for="Description" class="form-label">
                  {translation.description}
                </label>
                <textarea
                  class="form-control"
                  id="Post_desc"
                  rows="3"
                  placeholder="Describe Here"
                  name="Post_desc"
                  key="Post_desc"
                  defaultValue={selectMeeting?.post_task?.desc}
                  onChange={onInputChange}
                ></textarea>
              </div>
              <div class="col-12  mt-2">
                <label for="Remarks" class="form-label">
                  {translation.remarks}
                </label>
                <textarea
                  class="form-control"
                  id="Post_remarks"
                  rows="3"
                  placeholder="Remarks Here"
                  name="Post_remarks"
                  key="Post_remarks"
                  defaultValue={selectMeeting?.post_task?.remarks}
                  onChange={onInputChange}
                ></textarea>
              </div>
            </Tabs.TabPane>
          </Tabs>
          <div class="col-lg-12 mb-2 d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-danger px-3 py-2 me-2"
              onClick={() => onCancel()}
            >
              {translation.cancel}
            </button>
            <button
              type="button"
              class="btn btn-primary px-3 py-2"
              onClick={() => updateMeetingHandler()}
            >
              {translation.update}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditMeeting;
